import { useState } from 'react';
import { SelectOption } from '../../../models/select-option';
import Button from '../../ui/button/button';
import AutocompleteSearcher from '../autocomplete-searcher/autocomplete-searcher';
import Map from '../map/map';
import Section from '../../layout/section/section';
import { LatLng } from 'leaflet';
import madriwaService from '../../../services/madriwa-service/madriwa-service';
import { BoxArrowUpRight } from 'react-bootstrap-icons';

const DEFAULT_WAIT_THRESOLD_MS = 200;

type SearchSectionProps = {
  onCheckLocation?: (name: string, lat: number, long: number) => void;
};

export const SearchSection: React.FC<SearchSectionProps> = ({ onCheckLocation }) => {
  const [options, setOptions] = useState<SelectOption[]>([]);
  const [locationName, setLocationName] = useState<string>('');
  const [location, setLocation] = useState<LatLng>();

  let searchInputTimeOut: NodeJS.Timeout;

  const onCheckLocationHaandler = () => {
    location && onCheckLocation && onCheckLocation(locationName, location.lat, location.lng);
  };

  const onSearch = (searchValue: string) => {
    if (!searchValue) {
      setOptions([]);
      return;
    }

    clearTimeout(searchInputTimeOut);
    searchInputTimeOut = setTimeout(() => {
      madriwaService
        .fetchSuggestions(searchValue)
        .then((suggestions: any) => {
          const suggestedOptions: SelectOption[] = suggestions.map((suggestion: any) => {
            return {
              label: suggestion,
              value: suggestion,
            };
          });
          setOptions(suggestedOptions);
        })
        .catch((error: any) => {});
    }, DEFAULT_WAIT_THRESOLD_MS);
  };

  const onOptionSelected = (optionSelected: SelectOption | undefined) => {
    if (optionSelected) {
      madriwaService
        .getLocation(optionSelected.value)
        .then((location: any) => {
          setLocation(new LatLng(location.geom.coordinates[1], location.geom.coordinates[0]));
          setOptions([]);
          setLocationName(location.formatAddress);
        })
        .catch((error: any) => {});
    }
  };

  return (
    <Section className="bg-searchBgColor leading-5">
      <div className="flex flex-col items-center">
        <h1 className="pb-3 text-center text-[1.3rem] font-light text-madriwaGreen sm:text-[1.8rem]">
          ¿Estás en una isla de calor?
        </h1>
        <p className="max-w-[35rem] text-center text-[1.1rem] font-normal text-searchP">
          Introduce tu dirección y descubre si estás a más o menos temperatura que la media de tus
          alrededores (500 metros).
        </p>
        <p className="mt-3 text-center text-[0.8rem] font-normal leading-4 text-searchP">
          Este servicio sólo funciona con la ciudad de Madrid. <br />
          Si te interesa para tu ciudad, escribe a&nbsp;
          <a className="underline" href="mailto:hola@taniwa.es">
            hola@taniwa.es
          </a>
          <br />
          Hecho por:&nbsp;
          <a className="underline" href="https://www.taniwa.es/" target="blank">
            taniwa.es
            <BoxArrowUpRight className="relative bottom-[1px] ml-[2px] inline-block h-[10px] w-[10px] font-bold" />
          </a>
          &nbsp;expertos en datos y&nbsp;
          <a className="underline" href="https://geomatico.es/" target="blank">
            geomatico.es
            <BoxArrowUpRight className="relative bottom-[1px] ml-[2px] inline-block h-[10px] w-[10px] font-bold" />
          </a>
          &nbsp;expertos en <abbr title="Sistema de Información Geográfica">GIS</abbr>
        </p>
      </div>
      <div className="relative w-full flex-grow py-5">
        <div className="absolute left-0 top-5 z-500 w-full p-5">
          <AutocompleteSearcher
            className="drop-shadow"
            placeholder="Buscar dirección..."
            loading={false}
            options={options}
            selectedOption={undefined}
            onSearchValueChanged={onSearch}
            onOptionSelectedChanged={onOptionSelected}
          />
        </div>
        <Map className="" centerLatLng={location} />
      </div>
      <Button
        type="secondary"
        isDisabled={!location}
        label="comprobar"
        onClick={onCheckLocationHaandler}
      />
    </Section>
  );
};

export default SearchSection;
